<template>
  <el-card shadow="never" v-loading="unitsLoading">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Unit Vacancy Aging' }">Unit Vacancy Aging</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <location-picker @selected="(locations) => selectedFacilities = locations"> </location-picker>
    <el-card shadow="never">
      <el-row :gutter="20">
        <el-col :span="3" :offset="1">
          <el-tooltip
            content="Min Size"
            placement="top"
          >
            <el-input-number v-model="minSize" :step="100" placeholder="Min Size"></el-input-number>
          </el-tooltip>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-tooltip
            content="Max Size"
            placement="top"
          >
            <el-input-number v-model="maxSize" :step="100" placeholder="Max Size"></el-input-number>
          </el-tooltip>
        </el-col>
        <el-col :span="5" :offset="1">
          <el-radio-group v-model="type">
            <el-radio-button label="Warehouse"></el-radio-button>
            <el-radio-button label="Office"></el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="3" :offset="2">
          <el-button type="primary" round @click="getUnits">Search</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never" v-loading="unitsLoading">
      <el-table :data="units">
        <el-table-column prop="name" label="Unit Name"></el-table-column>
        <el-table-column label="Facility Code">
          <template slot-scope="scope">
            {{ scope.row.facility.code.toUpperCase() }}
          </template>
        </el-table-column>
        <el-table-column width="80" prop="computedSize" label="Size"></el-table-column>
        <el-table-column width="98" align="center" prop="tierQuality" label="Tier Quality">
          <template slot-scope="scope">
            {{ scope.row.tierQuality === 'AA' ? 'A+' : scope.row.tierQuality }}
          </template>
        </el-table-column>
        <el-table-column label="Price">
          <template slot-scope="scope">
            <el-tag>{{ computedPrice({ unit: scope.row, qualityPricing: scope.row.facility.pricing.qualityPricing, dTier: scope.row.facility.pricing.dTier, start: new Date() }) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Days Available">
          <template slot-scope="scope">
            {{ getDifference(scope.row.lastMoveOut ? scope.row.lastMoveOut : scope.row.createdDate ) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="!unitsLoading"
        hide-on-single-page
        background
        :total="totalCount"
        layout="prev, pager, next"
        @current-change="handlePages"
      >
      </el-pagination>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import { differenceInCalendarDays } from 'date-fns';
import LocationPicker from './LocationPicker.vue';
import { computeUnitPricing } from '../utils/pricing';
import { UNITS_API_BASE } from '../env';

export default {
  name: 'GlobalUnitVacancy',
  components: { LocationPicker },
  data() {
    return {
      unitsLoading: false,
      units: [],
      pages: 0,
      totalCount: 0,
      currentPage: 0,
      type: '',
      maxSize: null,
      minSize: null,
      selectedFacilities: null
    };
  },
  methods: {
    async handlePages(newPage) {
      this.currentPage = newPage;
      await this.getUnits();
    },
    async getUnits() {
      this.unitsLoading = true;
      try {
        if (!this.selectedFacilities|| !this.selectedFacilities.length) {
          this.$message.warning({
            message: 'Please select facilities',
          });
  
          return;
        }
        const units = await axios.get( `${UNITS_API_BASE}/units/vacancy`, {
          params: {
            facilities: this.selectedFacilities.toString(),
            ...(this.minSize ? { minSize: this.minSize } : {}),
            ...(this.maxSize ? { maxSize: this.maxSize } : {}),
            ...(this.currentPage ? { pageNumber: this.currentPage } : {}),
            type: this.type,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          }
        });

        this.units = units.data.result.units;
        this.totalCount = units.data.result.totalCount;
        this.pages = this.totalCount / 10;
        this.currentPage = units.data.result.pageNo;
      } catch (err) {
        this.$message.error({
          message: err.response && err.response.data ? err.response.data : err.message
        });
        this.units = [];
        this.totalCount = 0;
        this.currentPage = 0;
      }
      this.unitsLoading = false;
    },
    getDifference(date) {
      return differenceInCalendarDays( new Date(), new Date( date ) );
    },
    computedPrice(payload) {
      const { unit } = payload;
      const price = computeUnitPricing(unit, unit.facility);
      if (unit.status === 'AVAILABLE') {
        return Number(price).toLocaleString('en', { style: 'currency', currency: unit.facility.pricing.currency });
      }

      if (unit.facility.stillFullFlag) {
        const stillFullPrice = price * ( unit.facility.stillFullPrice / 100 );
        const stillFullRent = price + stillFullPrice;
        return Number(stillFullRent).toLocaleString('en', { style: 'currency', currency: unit.facility.pricing.currency });
      }

      return Number(price).toLocaleString('en', { style: 'currency', currency: unit.facility.pricing.currency });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/GlobalUnitVacancy.vue